enum MasterLog {
  EmailSent = 'email-sent',
  EmailFailed = 'email-failed',
  EmailBounced = 'email-bounced',
  UnsubscribedAuto = 'unsubscribed-auto',
  UnsubscribedManual = 'unsubscribed-manual',
  ReSubscribed = 'resubscribed',
  ReplyReceivedAuto = 'reply-received-auto',
  ReplyReceivedManual = 'reply-received-manual',
  ReplyReceived = 'reply-received',
  FinishedManual = 'finished-manual',
  EmailBouncedManual = 'email-bounced-manual',
  EmailReplied = 'email-replied',
  // EmailAccountDisconnected = 'email-account-disconnected',
  MailboxEmailSent = 'mailbox-email-sent',
  MailboxEmailOpened = 'mailbox-email-opened',
  MailboxEmailLinkClicked = 'mailbox-email-link-clicked',
  SequenceContactResumed = 'sequence-contact-resumed',
  SequenceContactPaused = 'sequence-contact-paused',
  SequenceContactPaused1 = 'prospect-manually-paused',
  UniboxEmailOpened = 'unibox-email-opened',
  UniboxEmailLinkClicked = 'unibox-email-link-clicked',
  PrimaryEmailChangedAuto = 'primary-email-changed-auto',
  PrimaryEmailChangedManual = 'primary-email-changed-manual',
  Unsubscribed = 'unsubscribed',
  MarkAsFinished = 'mark-as-finished',
  MarkAsReplied = 'mark-as-replied',
  SequencePaused = 'sequence-paused',
  SequenceResumed = 'sequence-resumed',
  PrimaryEmailNumberChanged = 'primary-email-number-changed',
  MovedColumn = 'kanban-column-updated',
  DeleteNote = 'note-deleted',
  SystemUpdate = 'system-update',
  MarkAsBounced = 'mark-as-bounced',
  NoteAdded = 'note-added',
  NoteEdited = 'note-edited',
  NoteAddedPublic = 'note-added-public',
  NoteAddedPrivate = 'note-added-private',
  NoteAddedPublicTask = 'note-added-public-task',
  NoteAddedPrivateTask = 'note-added-private-task',
  NoteMentioned = 'note-mention',
  NoteDeletedTask = 'note-deleted-task',
  NoteEditedTask = 'note-edited-task',
  CallMade = 'call-made',
  CallOutcomeChange = 'call-outcome-updated',
  CallOutcomeChangeForCallTask = 'call-outcome-updated-for-call-task',
  EmailSentAutomatically = 'email-sent-automatically',
  LinkedinTaskCreated = 'linkedin-task-created',
  CallTaskCreated = 'call-task-created',
  WhatsappTaskCreated = 'whatsapp-task-created',
  CustomTaskCreated = 'custom-task-created',
  EmailSentManually = 'email-sent-manually',
  EmailSentOneToOne = 'email-sent-one-to-one',
  UserSentManualEmail = 'user-sent-manual-email',
  TaskCreatedFromProfileTabs = 'task-created-from-profile-tabs',
  TaskSnoozed = 'task-snoozed',
  TaskSnoozedFromProspectTab = 'task-snoozed-from-prospect-tab',
  TaskSkipped = 'task-skipped',
  TaskSkippedFromProspectTab = 'task-skipped-from-prospect-tab',
  TaskCompleted = 'task-marked-as-complete',
  TaskCompletedFromProspectTab = 'task-marked-as-complete-from-prospect-tab',
  MissCall = 'incoming-call-missed',
  OutgoingCall = 'outgoing-call',
  IncomingCall = 'incoming-call-answered',
  ProfileFieldUpdated = 'profile-field-updated',
  Resubscribed = 'resubscribed',
  LinkClicked = 'link-clicked',
  EmailVerifier = 'email-verifier',
  // EmailVerifierFailed = 'email-verifier-failed',
  BadEmailVerifier = 'bad-email-verifier',
  AddToSequence = 'added-to-sequence',
  RemoveFromSequence = 'remove-from-sequence',
  Blacklisted = 'blacklisted',
  RemovedFromBlacklist = 'removed-from-blacklist',
  CallBlacklistedGlobalList = 'call-blacklisted-global-list',
  CallBlacklistedClientList = 'call-blacklisted-client-list',
  CallWhiteListedGlobalList = 'call-whitelisted-global-list',
  CallWhiteListedClientList = 'call-whitelisted-client-list',
  EmailOpened = 'email-opened',
  BulkProfileFieldUpdated = 'bulk-profile-field-updated',
  ProspectAdded = 'prospect-added',
  // AiColumnEnrichment = 'ai-column-enrichment',
  // AiColumnEnrichmentFailed = 'ai-column-enrichment-failed',
  // SequenceProspectExportForClient = 'sequence-prospect-export-client',
  // UniboxConversationForClient = 'unibox-conversation-client',
  // EmailAccountBulkConnectClient = 'email-account-bulk-connect-client',
  // SequenceReportClient = 'sequence-report-client',
  // ProspectVerifyReport = 'prospect-verify-report',
  // WhitelabelDomainSet = 'whitelabel-domain-set',
  // BlacklistedGlobalList = 'blacklisted-global-list',
  // BlacklistedClientList = 'blacklisted-client-list',
  // WhiteListedGlobalList = 'whitelisted-global-list',
  // WhiteListedClientList = 'whitelisted-client-list',
  // DncExport = 'dnc-export',
  // DncImport = 'dnc-import',
  // SequenceProspectImport = 'sequence-prospect-import',
  // SequenceProspectVerify = 'sequence-prospect-verify',
  // SequenceProspectBulkAction = 'sequence-prospect-bulk-action',
  // LeadRevealCompleted = 'lead-reveal-completed',
  // LeadRevealCompletedNoEmailOrPhone = 'lead-reveal-completed-no-email-or-phone',
  // LeadRevealCompletedAsync = 'lead-reveal-completed-async',
  // LeadRevealCompletedNoEmailOrPhoneAsync = 'lead-reveal-completed-no-email-or-phone-async',
  // DomainRegistrationInProgress = 'domain-registration-in-progress',
  // DomainRegistrationComplete = 'domain-registration-complete',
  // ProspectImportAsync = 'prospect-import-async',
  // SequenceProspectImportAsync = 'sequence-prospect-import-async',
  // MailboxRegistrationComplete = 'mailbox-registration-complete',
  LinkClickedNoSubject = 'link-clicked-no-subject',
  ProspectEmailVerification = 'prospect-email-verification',
  // LinkedIn Automation activity types
  LinkedInAutomationExecuted = 'linkedin-automation-executed',
  LinkedInAutomationExecutedRetry = 'linkedin-automation-executed-retry',
  LinkedInAutomationFailed = 'linkedin-automation-failed',
  LinkedInAutomationRetryFailed = 'linkedin-automation-retry-failed',
  LinkedInAutomationPushed = 'linkedin-automation-pushed',
  LinkedInAutomationRetrying = 'linkedin-automation-retrying',
  LinkedInAutomationSkipped = 'linkedin-automation-skipped',
  LinkedInAutomationTaskCompleted = 'linkedin-automation-task-completed',
  LinkedInAutomationTaskSkipped = 'linkedin-automation-task-skipped',
  LinkedInAutomationTaskFailed = 'linkedin-automation-task-failed',
}

export default MasterLog;
